'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.toRGB = toRGB;
exports.darken = darken;
exports.lighten = lighten;
exports.rgba = rgba;
exports.getColorPair = getColorPair;
exports.getLuminance = getLuminance;
exports.isLight = isLight;
exports.isDark = isDark;
exports.isHEX = isHEX; // color name generated by http://chir.ag/projects/name-that-color/
// Orange

var tango = exports.tango = '#F06E1D';
var jaffa = exports.jaffa = '#F47D31';
var tanHide = exports.tanHide = '#F58B44';
var sandyBrown = exports.sandyBrown = '#f5a571'; // Plum

var scarpaFlow = exports.scarpaFlow = '#524D57';
var scarpaFlow2 = exports.scarpaFlow2 = '#544F59';
var saltBox = exports.saltBox = '#67626E';
var mobster = exports.mobster = '#7A7482'; // Purple

var trout = exports.trout = '#4B5161';
var comet = exports.comet = '#5A6175';
var slateGrey2 = exports.slateGrey2 = '#626A7F';
var baliHai = exports.baliHai = '#828DAB'; // Chocolate

var emperor = exports.emperor = '#514241';
var dorado = exports.dorado = '#665352';
var sandDune = exports.sandDune = '#7A6462';
var hemp = exports.hemp = '#8F7472'; // Yellow

var rajah = exports.rajah = '#F5C471';
var goldenrod = exports.goldenrod = '#FACA78';
var salomie = exports.salomie = '#FED58C';
var navajoWhite = exports.navajoWhite = '#FFDEA6'; // Red

var burntSienna = exports.burntSienna = '#E85D4A';
var burntSienna2 = exports.burntSienna2 = '#F1624E';
var bittersweet = exports.bittersweet = '#FC6E5B';
var salmon = exports.salmon = '#FF7C6B'; // Pink

var mandy = exports.mandy = '#E8646F';
var froly = exports.froly = '#F26C77';
var geraldine = exports.geraldine = '#FC7C86';
var pinkSalmon = exports.pinkSalmon = '#FF8F98'; // Peach

var burntSienna3 = exports.burntSienna3 = '#ED6F68';
var froly2 = exports.froly2 = '#F07973';
var froly3 = exports.froly3 = '#F28883';
var seaPink = exports.seaPink = '#F19B96'; // Violet

var lilac = exports.lilac = '#D7A5D2';
var thistle = exports.thistle = '#D7B2D4';
var melanie = exports.melanie = '#E0BCDD';
var melanie2 = exports.melanie2 = '#EBCAE8'; // Periwinkle

var portage = exports.portage = '#8A9AED';
var portage2 = exports.portage2 = '#93A2ED';
var portage3 = exports.portage3 = '#9DAAED';
var perano = exports.perano = '#A6B2ED'; // Blue

var havelockBlue = exports.havelockBlue = '#4592D1';
var danube = exports.danube = '#559AD1';
var havelockBlue2 = exports.havelockBlue2 = '#64A4D9';
var seagull = exports.seagull = '#73B5EB'; // Sky

var viking = exports.viking = '#52B6DE';
var viking2 = exports.viking2 = '#64BBDE';
var seagull2 = exports.seagull2 = '#72C7E8';
var malibu = exports.malibu = '#80D2F2'; // Aqua

var fountainBlue = exports.fountainBlue = '#55C2BB';
var downy = exports.downy = '#67C7C1';
var monteCarlo = exports.monteCarlo = '#7BCDC8';
var monteCarlo2 = exports.monteCarlo2 = '#8ED1CD'; // Green

var deYork = exports.deYork = '#77C79F';
var vistaBlue = exports.vistaBlue = '#86D1AC';
var vistaBlue2 = exports.vistaBlue2 = '#96D9B0';
var surf = exports.surf = '#BDDEC2'; // Stone

var carrarra = exports.carrarra = '#EBE8E4';
var pampas = exports.pampas = '#EFECE7';
var springWood = exports.springWood = '#F5F2ED';
var merino = exports.merino = '#FAF7F2'; // Pale

var janna = exports.janna = '#F4E6D4';
var albescentWhite = exports.albescentWhite = '#F7ECDC';
var linen = exports.linen = '#FAF0E3';
var linen2 = exports.linen2 = '#FCF5EB'; // Sand

var almond = exports.almond = '#EDD4C2';
var almond2 = exports.almond2 = '#F0D9C9';
var almond3 = exports.almond3 = '#F2DED0';
var albescentWhite2 = exports.albescentWhite2 = '#F5E4D7'; // Grey Scale

var black = exports.black = '#000000';
var codBlack = exports.codBlack = '#191919';
var mineShaft = exports.mineShaft = '#333333';
var tundora = exports.tundora = '#4c4c4c';
var doveGrey = exports.doveGrey = '#666666';
var grey = exports.grey = '#7f7f7f';
var dustyGrey = exports.dustyGrey = '#999999';
var silverChalice = exports.silverChalice = '#b2b2b2';
var silver = exports.silver = '#cccccc';
var mercury = exports.mercury = '#e5e5e5';
var white = exports.white = '#ffffff'; // TODO: fix naming to allow 0.9 -> 0.1 without gaps

var opaqueWhite = exports.opaqueWhite = rgba(white, 0.97); // blame ken

var hazyWhite = exports.hazyWhite = rgba(white, 0.9);
var clearWhite = exports.clearWhite = rgba(white, 0.5);
var dimWhite = exports.dimWhite = rgba(white, 0.3);
var dimmerWhite = exports.dimmerWhite = rgba(white, 0.2);
var dimmestWhite = exports.dimmestWhite = rgba(white, 0.1);
var dimBlack = exports.dimBlack = 'rgba(0, 0, 0, 0.3)';
var dimmestBlack = exports.dimmestBlack = 'rgba(0, 0, 0, 0.1)';
var dimmerComet = exports.dimmerComet = rgba(comet, 0.2);
var dimMineShaft = exports.dimMineShaft = 'rgba(51, 51, 51, 0.4)'; // basic mappings

var blue = exports.blue = comet;
var teal = exports.teal = monteCarlo;
var yellow = exports.yellow = salomie;
var orange = exports.orange = tango;
var pink = exports.pink = pinkSalmon;
var darkGray = exports.darkGray = tundora;
var lightGray = exports.lightGray = pampas;
var colorPairs = exports.colorPairs = {
  pampas: comet,
  comet: white,
  merino: comet,
  white: comet
};

function toRGB() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : comet;
  var bigint = parseInt(hex.replace(/[^0-9A-F]/gi, ''), 16);
  return [bigint >> 16 & 255, bigint >> 8 & 255, bigint & 255];
}

function darken(hex, percent) {
  var rgb = toRGB(hex);
  var darker = rgb.map(function (v) {
    var percentage = v * percent;
    return Math.floor(v - percentage);
  });
  return 'rgb(' + darker.join(',') + ')'; // should return hex
}

function lighten(hex, percent) {
  var rgb = toRGB(hex);
  var darker = rgb.map(function (v) {
    var percentage = (v + 1) * percent;
    return Math.floor(v + percentage);
  });
  return 'rgb(' + darker.join(',') + ')'; // should return hex
}

function rgba(hex, alpha) {
  var rgb = toRGB(hex);
  return 'rgba(\n    ' + rgb.join(',') + ',\n    ' + alpha + '\n  )';
}

function getColorPair(hex) {
  return Object.keys(colorPairs).reduce(function (accum, key) {
    var _hex = colorPairs[key];

    if (hex === _hex) {
      return key;
    }
  }, null);
}

function getLuminance(hex) {
  var _toRGB = toRGB(hex),
      _toRGB2 = _slicedToArray(_toRGB, 3),
      r = _toRGB2[0],
      g = _toRGB2[1],
      b = _toRGB2[2];

  return (r * 0.299 + g * 0.587 + b * 0.114) / 256;
}

function isLight(hex) {
  var luminance = getLuminance(hex);
  return luminance >= 0.6;
}

function isDark(hex) {
  var luminance = getLuminance(hex);
  return luminance <= 0.59;
}

function isHEX(val) {
  return val && !!val.match(/^#/);
}